import React from 'react';

const IamExAuditTableCell = ({user, actions}) => {

  actions.forEach(actionObj => {

    const regexFindFunction = action => {
      const regex = new RegExp(`^${action.replace('*', '.*')}$`, 'i');
      return regex.test(actionObj.action);
    };

    const sameAccountPolicyArrays = [
      {
        array: user.ManagedPolicies,
        type: 'Managed Policy'
      },
      {
        array: user.InlinePolicies,
        type: 'Inline Policy'
      },
      {
        array: user.ManagedGroupPolicies,
        type: 'Managed Group Policy'
      },
      {
        array: user.InlineGroupPolicies,
        type: 'Inline Group Policy'
      },
    ];

    sameAccountPolicyArrays.forEach(policyArray => {
      policyArray.array.forEach(policy => {

        const policyName = policy.PolicyName;

        policy.PolicyDocument.Statement.forEach(statement => {
          if ((statement.Action && statement.Action.find(regexFindFunction)) || (statement.NotAction && !statement.NotAction.find(regexFindFunction))) {
            const newPolicy = {
              policy: policyName,
              resource: statement.Resource,
              effect: statement.Effect,
              type: policyArray.type
            };
            if (!actionObj.accounts[0].policies.find(policy => {
              return JSON.stringify(policy) === JSON.stringify(newPolicy);
            })) actionObj.accounts[0].policies.push(newPolicy);
          };
        });

      });
    });

    [user.AssumeRoleInlinePolicies, user.AssumeRoleManagedPolicies].forEach(policyArray => {
      policyArray.forEach(policy => {
        let thisAccount = actionObj.accounts.find(account => {
          return `${policy.Account} (${policy.AccountId})` === account.account;
        });
        if (!thisAccount) {
          actionObj.accounts.push({account: `${policy.Account} (${policy.AccountId})`, policies: []});
          thisAccount = actionObj.accounts.find(account => {
            return `${policy.Account} (${policy.AccountId})` === account.account;
          });
        }

        const policyName = policy.PolicyName;

        policy.PolicyDocument.Statement.forEach(statement => {
          if ((statement.Action && statement.Action.find(regexFindFunction)) || (statement.NotAction && !statement.NotAction.find(regexFindFunction))) {
            const newPolicy = {
              policy: policyName,
              resource: statement.Resource,
              effect: statement.Effect,
              type: policyArray.type
            };
            if (!thisAccount.policies.find(policy => {
              return JSON.stringify(policy) === JSON.stringify(newPolicy);
            })) thisAccount.policies.push(newPolicy);
          };
        });

      });
    });

  });

  return (
    <td className="IamExAuditTableCellPage">
      {actions.filter(action => action.accounts.some(account => account.policies.length > 0)).map(action => {
        return (
          <div key={action.action}>
            <p className="CellAction">{action.action}</p>
            {action.accounts.filter(account => account.policies.length > 0).map(account => {
              return (
                <div key={account.account}>
                  <p className="CellAccount">{`${account.account}`}</p>
                  {account.policies.map(policy => {
                    return (
                      <div key={JSON.stringify(policy)}>
                        <p className={`CellPolicy${policy.effect}`}>{`${policy.effect} on "${policy.resource.join(', ')}" resource(s) via ${policy.type} "${policy.policy}"`}</p>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
    </td>
  );

};

export default IamExAuditTableCell;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExActions/iamExAcUserPermissions/iamExAcAuditTableRow/iamExAcAuditTableCell/iamExAcAuditTableCell.js